'use client';
import { supportsPassiveEvents } from '@s7/platform';

const passiveListenerOptions = supportsPassiveEvents ? {
    passive: false
} : false;

export { passiveListenerOptions };
//# sourceMappingURL=passiveListenerOptions.js.map
